import {
  CREATE_RATE_REFERENCE,
  CREATE_RATE_REFERENCE_RESPONSE,
  CREATE_RATE_REFERENCE_RESPONSE_FAIL,
  DELETE_RATE_REFERENCE,
  DELETE_RATE_REFERENCE_RESPONSE,
  DELETE_RATE_REFERENCE_RESPONSE_FAIL,
  GET_RATE_REFERENCE,
  GET_RATE_REFERENCE_RESPONSE,
  GET_RATE_REFERENCE_RESPONSE_FAIL,
  GET_RATE_REFERENCES,
  GET_RATE_REFERENCES_RESPONSE,
  GET_RATE_REFERENCES_RESPONSE_FAIL,
  RESET,
  UPDATE_RATE_REFERENCE,
  UPDATE_RATE_REFERENCE_RESPONSE,
  UPDATE_RATE_REFERENCE_RESPONSE_FAIL,
} from "./actions";

const initialState = {
  isLoading: false,
  error: null,
  data: {
    rateReferencesList: {
      items: [],
    },
    rateReference: null,
    searchQuery: null,
    range: { start: 0, end: 25 },
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return Object.assign({}, initialState);

    case GET_RATE_REFERENCES:
    case GET_RATE_REFERENCE:
    case CREATE_RATE_REFERENCE:
    case UPDATE_RATE_REFERENCE:
    case DELETE_RATE_REFERENCE:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case GET_RATE_REFERENCES_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          rateReferencesList: {
            ...state.data.rateReferencesList,
            items: action.rateReferences,
          },
        },
        error: null,
        isLoading: false,
      };

    case GET_RATE_REFERENCE_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          rateReference: action.rateReference,
        },
        error: null,
        isLoading: false,
      };

    case CREATE_RATE_REFERENCE_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          rateReference: action.rateReference,
          rateReferencesList: {
            ...state.data.rateReferencesList,
            items: [...state.data.rateReferencesList.items, action.rateReference],
          },
        },
        error: null,
        isLoading: false,
      };

    case UPDATE_RATE_REFERENCE_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          rateReference: action.rateReference,
          rateReferencesList: {
            ...state.data.rateReferencesList,
            items: state.data.rateReferencesList.items.map((item) =>
              item.uuid === action.rateReference.uuid ? action.rateReference : item
            ),
          },
        },
        error: null,
        isLoading: false,
      };

    case DELETE_RATE_REFERENCE_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          rateReferencesList: {
            ...state.data.rateReferencesList,
            items: state.data.rateReferencesList.items.filter(
              (item) => item.uuid !== action.uuid
            ),
          },
        },
        error: null,
        isLoading: false,
      };

    case GET_RATE_REFERENCES_RESPONSE_FAIL:
    case GET_RATE_REFERENCE_RESPONSE_FAIL:
    case CREATE_RATE_REFERENCE_RESPONSE_FAIL:
    case UPDATE_RATE_REFERENCE_RESPONSE_FAIL:
    case DELETE_RATE_REFERENCE_RESPONSE_FAIL:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    default:
      return {
        ...state,
      };
  }
};
